export { default } from './WindGraph';
